import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useState } from 'react';
import { useAuthenticatedQuery } from '../../../../client/hooks';
import { useAppState } from '../../../../client/providers/AppProvider';
import {
    GetChildProfilesDocument,
    GetChildProfilesQuery,
    GetChildProfilesQueryVariables,
} from '../../../../generated/spin-graphql';
import { useMessagesContext } from '../../../../pages/dashboard/messages';
import { ParentChildDropdown } from '../../ParentChildDropdown';

export const ParentMessages: React.FC = () => {
    const { user } = useAppState();
    const { messagesDispatch } = useMessagesContext();
    const router = useRouter();

    const [selectedChild, setSelectedChild] = useState(0);
    const { isReady: childProfileReady, data: childProfileData } = useAuthenticatedQuery<
        GetChildProfilesQuery,
        GetChildProfilesQueryVariables
    >({
        query: GetChildProfilesDocument,
        variables: useMemo(() => ({ id: user?.id }), [user]),
        pause: !!!user?.parent_profile?.child_profiles,
    });
    const hasMultipleChildren = childProfileData?.espin_parent_profile[0]?.child_profiles.length > 1;

    useEffect(() => {
        if (childProfileReady) {
            messagesDispatch({
                type: 'setSelectedChild',
                selectedChildId: childProfileData?.espin_parent_profile[0]?.child_profiles[selectedChild].user_id,
            });
        }
    }, [childProfileData, childProfileReady, messagesDispatch, selectedChild]);

    return (
        <>
            {childProfileReady && hasMultipleChildren && (
                <div className="parent-dropdown-container">
                    <ParentChildDropdown
                        playerInfo={childProfileData.espin_parent_profile}
                        value={childProfileData.espin_parent_profile[0].child_profiles[selectedChild]}
                        onChange={(value) => {
                            router.push('/dashboard/messages/', undefined, { shallow: true });
                            setSelectedChild(value);
                            messagesDispatch({ type: 'setSelectedIndex', index: undefined });
                        }}
                    />
                </div>
            )}
        </>
    );
};
